import * as Yup from 'yup';

export const ManageAdminValidationSchema = (t: any) =>
    Yup.object({
        firstName: Yup.string()
            .min(2, t('firstname_min_length_validation'))
            .max(30, t('firstname_max_length_validation'))
            .trim(t('space_not_allowed_validation'))
            .required(t('firstname_required_validation')),
        lastName: Yup.string()
            .min(2, t('lastname_min_length_validation'))
            .max(30, t('lastname_max_length_validation'))
            .trim(t('space_not_allowed_validation'))
            .required(t('lastname_required_validation')),
        email: Yup.string()
            .email(t('invalid_email_validation'))
            .trim(t('space_not_allowed_validation'))
            .required(t('email_required_validation')),
        country: Yup.string().required(t('country_required_validation')),
        mobileNo: Yup.string()
            .min(10, t('mobileno_min_length_validation'))
            .max(10, t('mobileno_max_length_validation'))
            .matches(/^\+?[0-9\s\-().]{7,20}$/, 'Please enter a valid Mobile number')
            .required(t('mobile_no_required_validation')),
        role: Yup.number().required(t('role_required_validation')),
    });
